import { connect } from 'react-redux';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import checkIsMobile, { isInStandaloneMode } from 'shared/utils/checkMobileDevice';

import ExternalConferencePage from './ExternalConferencePage';

export default connect(
  state => {
    const isAppointmentFetched = state.appointmentInfo.currentAppointment.requestStatus === requestsStatuses.success;

    return {
      isMobile: checkIsMobile(),
      isInStandaloneMode: isInStandaloneMode(),
      isAppointmentFetching: !isAppointmentFetched,
    };
  },
)(ExternalConferencePage);
